import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=7031af16&scoped=true&"
import script from "./CollapsibleSection.vue?vue&type=script&lang=js&"
export * from "./CollapsibleSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/custom-style.css?vue&type=style&index=0&id=7031af16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031af16",
  null
  
)

export default component.exports